import { useLang } from '../i18n'
import { importOffers, type ImportPanel, type ImportOffersJob } from '../lib/slide-import'

/**
 * "Import report" and "Compare with original" of a done import, as a job's details and the import
 * dialog's end both offer them (AB#462): neither for a picture import, whose slide is its own
 * original; no comparison once the originals' 2 days are over, a line saying so instead. Each opens
 * the part in the editor with that panel, which is `onOpen`'s to do.
 */
export function ImportPanelButtons({ job, onOpen }: { job: ImportOffersJob; onOpen: (panel: ImportPanel) => void }) {
  const { t } = useLang()
  const offers = importOffers(job, Date.now())
  if (!offers.report && !offers.compare && !offers.originalsGone) return null
  return (
    <div className="job-panels">
      {offers.originalsGone && <p className="pptx-note">{t('jobs_originals_gone')}</p>}
      {(offers.report || offers.compare) && (
        <div className="job-panels-btns">
          {offers.report && (
            <button type="button" className="mini no" onClick={() => onOpen('report')}>
              {t('sl_import_report')}
            </button>
          )}
          {offers.compare && (
            <button type="button" className="mini no" title={t('sl_compare_hint')} onClick={() => onOpen('compare')}>
              {t('sl_compare')}
            </button>
          )}
        </div>
      )}
    </div>
  )
}
